import React from 'react'
import { SingleAnswer, Step } from '../../components'

const USES = {
  key: 'mote_use',
  trackingKey: 'mote_uses',
  question: 'How do you expect to use Mote?',
  choices: [
    { icon: '📢', text: 'Marketing', value: 'marketing' },
    { icon: '⚙️', text: 'Support', value: 'support' },
    { icon: '📦', text: 'Product', value: 'product' },
    { icon: '💰', text: 'Finance', value: 'finance' },
    { icon: '⚕️', text: 'Medical', value: 'medical' },
    { icon: '🍏', text: 'Education', value: 'education' },
    { text: 'Other', value: 'other' }
  ]
}

export const OtherMoteUse = ({ index }) => {
  return (
    <Step
      index={index}
      trackingKey={USES.trackingKey}
      itemsCount={USES.choices.length}
      title={USES.question}
      subtitle='Select one (Required)'
    >
      {USES.choices.map(({ icon, text, value }) => (
        <SingleAnswer
          key={`${text}-${value}`}
          question={USES.question}
          surveyKey={USES.key}
          text={text}
          icon={icon}
          value={value}
        />
      ))}
    </Step>
  )
}
